var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.attribute === "name"
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" done ")])
    : _vm.attribute === "message"
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" send ")])
    : _vm.attribute === "email"
    ? _c("span", { staticClass: "material-icons" }, [
        _vm._v(" alternate_email "),
      ])
    : _vm.attribute === "phone"
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" phone ")])
    : _vm.attribute === "language"
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" language ")])
    : _vm.attribute === "timezone"
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" schedule ")])
    : _vm.attribute === "hour"
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" timer ")])
    : _vm.attribute === "weekday"
    ? _c("span", { staticClass: "material-icons" }, [
        _vm._v(" calendar_month "),
      ])
    : _vm.attribute === "segments"
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" pie_chart ")])
    : _vm.attribute === "tags"
    ? _c("span", { staticClass: "material-icons" }, [_vm._v("tag")])
    : _vm.attribute === "gender"
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" male ")])
    : _vm.attribute === "country"
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" place ")])
    : _vm.attribute === "referrer"
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" language ")])
    : _vm.attribute === "url"
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" link ")])
    : _vm.attribute === "ip"
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" laptop ")])
    : _vm.attribute === "last_seen"
    ? _c("span", { staticClass: "material-icons" }, [
        _vm._v(" calendar_today "),
      ])
    : _vm.attribute === "user_id"
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" fingerprint ")])
    : _vm.attribute === "department"
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" category ")])
    : _vm.attribute === "available_agents"
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" support_agent ")])
    : _vm.attribute === "idleUserTime"
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" hourglass_top ")])
    : _vm.attribute === "ai_class_result"
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" alt_route ")])
    : _vm.attribute === "platform"
    ? _c("span", { staticClass: "material-icons text-primary" }, [
        _vm._v(" hub "),
      ])
    : _vm.attribute === "channelId"
    ? _c("span", { staticClass: "material-icons text-primary" }, [
        _vm._v(" mediation "),
      ])
    : _vm.attribute === "metaReferrals"
    ? _c("span", { staticClass: "material-icons text-primary" }, [
        _vm._v(" bolt "),
      ])
    : _vm.attribute === "offline_mode"
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v(" wifi_off "),
      ])
    : _c("span", { staticClass: "material-icons" }, [_vm._v(" data_object ")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }